export enum DocumentStatus {
  InProgress = 'InProgress',
  Uploaded = 'Uploaded',
}

export enum DocumentType {
  COMDOCS = 0,
  COMM_INV = 1,
  PACK_LIST = 2,
  SHIPINST = 3,
  SED = 4,
  COO = 5,
  HAZMAT = 6,
  MSDS = 7,
  ORIGINCUST = 8,
  FUMC = 9,
  WOODPACK = 10,
  PROINV = 11,
  CUST_OTHER = 100,
}

export const DocumentTypeDisplay: Record<DocumentType, string> = {
  [DocumentType.FUMC]: 'Fumigation Certificate',
  [DocumentType.HAZMAT]: 'Hazmat Verification Doc',
  [DocumentType.MSDS]: 'Material Safety Data Sheet',
  [DocumentType.COMDOCS]: 'Intl Commercial Documents',
  [DocumentType.SHIPINST]: 'Intl Shipper Instructions',
  [DocumentType.PROINV]: 'Proforma Invoice',
  [DocumentType.SED]: 'Intl Shipper Export Declaration',
  [DocumentType.WOODPACK]: 'Intl Wood Packing List',
  [DocumentType.COO]: 'Certificate of Origin',
  [DocumentType.COMM_INV]: 'Intl Commercial Invoice',
  [DocumentType.ORIGINCUST]: 'Export License',
  [DocumentType.PACK_LIST]: 'Packing List',
  [DocumentType.CUST_OTHER]: 'Other'
};
